import { IFormValues } from '../../../containers/Form/CreateRoom'
import { IRoom } from '../index'

export default function(room: IRoom, profile: any = undefined): IFormValues {
  return {
    id: room.id,
    additionalBeds: Number(room.additionalBeds),
    additionalEquipment: room.additionalEquipment,
    city: room.city || (profile && profile.city) || '',
    coords_lat: Number(room.coords_lat) === 0 ? undefined : room.coords_lat,
    coords_lng: Number(room.coords_lng) === 0 ? undefined : room.coords_lng,
    customColor: room.customColor.rgb().toString(),
    description: room.description,
    doubleBed: Number(room.doubleBed),
    googleMapGeocoding:
      (Number(room.coords_lat) === 0 ? undefined : room.coords_lat) &&
      (Number(room.coords_lng) === 0 ? undefined : room.coords_lng)
        ? `${String(room.coords_lat)},${String(room.coords_lng)}`
        : '',
    id_country: room.id_country || (profile && profile.idCountry) || '',
    name: room.name,
    position: room.position ? Number(room.position) : 1,
    post_code: room.post_code || (profile && profile.postCode) || '',
    roomSize: Number(room.roomSize),
    serviceBedding: room.serviceBedding,
    serviceCleaning: room.serviceCleaning,
    serviceCleaningStage: room.serviceCleaningStage,
    serviceTowels: room.serviceTowels,
    singleBed: Number(room.singleBed),
    size: room.size,
    street: room.street || (profile && profile.street) || '',
    title: room.title,
    type: room.type,
    widget: room.widget,
  }
}
